import React, { Component, useEffect, useState, useRef } from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { alertActions, commonActions, questionActions } from '../../store/actions'
import { valid } from '../../hook/valid'
import history from '../../route/history'
import * as Common from '../../assets/js/common.js'

const QuestionWrite = (props) => {
  const MODE_REGIS = 'REGIS',
    MODE_EDIT = 'EDIT'
  const fileRef = React.useRef(new Array(3))
  const inputRef = React.useRef(new Array(6))

  const [mode, setMode] = useState(MODE_REGIS)
  const [seq, setSeq] = useState('')
  const [cteCode, setCteCode] = useState([])
  const [originFile, setOriginFile] = useState([])
  const [counter, setCounter] = useState(0)

  const [state, setState] = useState({
    questCd: '',
    regName: '',
    encPasswd: '',
    idEmail: '',
    mobileNo: '',
    questTitle: '',
    question: '',
    files: new Array(3),
    delFileIds: [],
    openYn: 'N',
  })

  /**
   * 최초 진입시 구분(등록, 수정)
   */
  useEffect(() => {
    props.getCommonCode({ mainCd: 'QNA_CATEGORY_CD' })
    let paramSeq = props.location?.state?.seq
    paramSeq && (paramSeq = paramSeq.toString())

    if (paramSeq?.length > 0) {
      setSeq(paramSeq)
      setMode(MODE_EDIT)
      console.log('token', props.token)
      props.detail(paramSeq, { mode: 'EDIT', token: props.token })
    }
  }, [])

  /**
   * 수정일 경우 초기 데이터 설정
   */
  useEffect(() => {
    if (mode === MODE_EDIT) {
      let select = props.select
      let obj = {
        ...state,
        questCd: select?.questCd,
        regName: select?.regName,
        idEmail: select?.idEmail,
        mobileNo: select?.mobileNo,
        questTitle: select?.questTitle,
        question: select?.question,
      }

      if (select?.ptlFileDtoList) {
        let editFile = []
        select.ptlFileDtoList.map((item) => {
          editFile.push({ name: item?.originFileNm, isOrigin: true, fileId: item?.fileId })
        })

        obj.files = editFile
      }
      setState(obj)

      setOriginFile(select?.ptlFileDtoList)
    }
  }, [props.select])

  /**
   * 공통코드 조회
   */
  useEffect(() => {
    setCteCode(props.cteCode)

    if (!props.cteCode && props.codeFail === true) {
      props.success({
        message: '오류가 발생했습니다.\n이 오류가 지속되면 관리자에게 문의하세요.',
        params: {
          type: 'SUCCESS',
          callback: () => {
            history.goBack()
          },
        },
      })
    }
  }, [props.cteCode])

  /**
   * 등록완료처리
   */
  useEffect(() => {
    props.registResult &&
      props.success({
        message: (mode === MODE_EDIT ? '수정' : '등록') + '완료되었습니다.',
        params: {
          type: 'SUCCESS',
          callback: () => {
            props.registReset()
            history.replace('/question')
          },
          cancelCallback: () => {
            props.registReset()
            history.replace('/question')
          },
        },
      })
  }, [props.registResult])

  /**
   * 등록
   */
  const regist = (e) => {
    if (!checkValid()) return

    // 중복생성 막기
    if (counter > 0) return
    props.regis(state)
    setCounter((counter) => counter + 1)
  }

  /**
   * 수정
   */
  const edit = () => {
    if (!checkValid()) return

    // 중복생성 막기
    if (counter > 0) return

    state.seq = seq
    state.token = props.token
    props.edit(state)
    setCounter((counter) => counter + 1)
  }
  /**
   * 유효성 체크
   * @param e
   * @returns {*}
   */
  const checkValid = () => {
    // if(!props.checkFindInput({ name: state.regName })){
    //   return inputRef.current[0].focus();
    // }

    // email, 전화번호 필수 값 제거
    // if(!props.checkFindInput({ email:state.idEmail })){
    //   return inputRef.current[1].focus();
    // }
    // if(!props.checkFindInput({ phone: state.mobileNo })){
    //   return inputRef.current[2].focus();
    // }

    if (state.questCd?.length <= 0) {
      props.error({ message: '카테고리를 선택해주세요.' })
      return inputRef.current[6].focus()
    }

    // 패스워드는 등록 시만 필수 값 체크
    if (mode === MODE_REGIS && state.encPasswd?.length <= 0) { // 이전 : 패스워드 입력했을 경우에만 체크
                                // 이후 : 패스워드 필수로 입력하도록 체크&& state.encPasswd && state.encPasswd.length < 4) {
      props.error({ message: '비밀번호를 입력해주세요.' })
      return inputRef.current[3].focus()
    }

    if (state.questTitle?.length <= 0) {
      props.error({ message: '문의 제목을 입력해주세요.' })
      return inputRef.current[4].focus()
    }

    if (state.question?.length <= 0) {
      props.error({ message: '문의 내용을 입력해주세요.' })
      return inputRef.current[5].focus()
    }
    if (state.question?.length > 2000) {
      props.error({ message: '문의 내용은 2000Byte를 초과 할 수 없습니다.' })
      return inputRef.current[5].focus()
    }

//      2025 ISMS 모든 문의는 비밀글로 등록하도록 수정
//     if (state.encPasswd.length >= 4) {
//       setState({
//         ...state,
//         openYn: 'Y',
//       })
//     } else {
//       setState({
//         ...state,
//         openYn: 'N',
//       })
//     }

    return true
  }

  /*   const setFile = (e, i) => {
    if (e.target?.files.length < 1) return;

    fileList[i] = {
      docFileName: e.target?.files[0].name,
      docFile: e.target?.files[0],
      docKey: e.target.id
    }

    setFileList([...fileList]);
  } */

  /**
   * 파일첨부
   * @param e
   */
  const onAttachFile = (e) => {
    let stateFiles = state.files
    const { name, files } = e.target
    let idx = parseInt(name.substr(4, 5))
    let obj = { ...state }

    if (files[0].name.indexOf('.exe') != -1) {
      return props.error({ message: 'EXE 파일은 등록이 안됩니다.' })
    }

    if (mode === MODE_EDIT && stateFiles[idx]) {
      obj.delFileIds.push(stateFiles[idx].fileId)
    }

    obj.files[idx] = files[0]
    setState(obj)
  }

  /**파일 삭제**/
  const delFile = (idx) => {
    let files = state.files
    let delFileIds = state.delFileIds

    if (state.files[idx].isOrigin) {
      delFileIds.push(state.files[idx].fileId)
    }
    files.splice(idx, 1)

    setState({
      ...state,
      delFileIds,
      files,
    })

    // 첨부파일 '업로드' 파일 선택 > '삭제' 후 재 업로드 시도 시 첨부파일 첨부 안됨
    // => 요소의 change 이벤트 발생 안되서 발생하는 오류
    fileRef.current[idx].value = '' // input 요소 값 초기화
  }

  const reset = (type) => {
    if (type === 'modify') {
      setState({
        files: new Array(3),
        questCd: '',
        questTitle: '',
        question: '',
      })
    } else {
      setState({
        encPasswd: '',
        files: new Array(3),
        questCd: '',
        questTitle: '',
        question: '',
      })
    }
  }

  const handleChange = (e) => {
    const { name, value } = e.target
    setState({
      ...state,
      [name]: value,
    })
  }

  const prePage = (e) => {
    e.preventDefault()
    window.history.back()
  }

  const generateFileInput = (idx) => {
    return (
      <React.Fragment>
        <li>
          <input
            className="form-keyword full"
            readOnly
            type="text"
            title="첨부파일"
            value={state.files[idx]?.name || ''}
            placeholder="첨부파일"
            style={{ width: '80%', marginRight: '10px' }}
          />
          <span className="btn-primary md cursor" onClick={() => fileRef.current[idx].click()}>
            찾아보기
          </span>
          <input
            type="file"
            title="fileInput"
            ref={(ref) => (fileRef.current[idx] = ref)}
            onChange={onAttachFile}
            style={{ display: 'none' }}
            name={'file' + idx}
            accept=".jpg,.jpeg,.bmp,.png,.pdf,.hwp,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt"
          />
          {state.files[idx] ? (
            <a href="#" className="btn-secondary md" onClick={() => delFile(idx)}>
              삭제
            </a>
          ) : (
            ''
          )}
        </li>
      </React.Fragment>
    )
  }

  return (
    <React.Fragment>
      <main>
        <div id="contents">
          <div className="content-header">
            <a onClick={prePage} className="page-prev">
              뒤로이동
            </a>{' '}
            {/* mobile */}
            <h2>문의하기</h2>
            <div className="breadcrumb">
              <span>Home</span>
              <span>고객센터</span>
              <em>문의하기</em>
            </div>
          </div>
          <p className="required">* 표시는 필수 입력사항입니다.</p>
          <table className="tbl-write">
            <caption>카테고리, 비밀번호, 제목, 내용 항목으로 구성</caption>
            <colgroup>
              <col className="col1" />
              <col />
            </colgroup>
            <tbody>
              <tr>
                <th scope="row">
                  <em className="required"></em> 카테고리
                </th>
                <td>
                  <select
                    title="카테고리"
                    name="questCd"
                    value={state.questCd || ''}
                    onChange={handleChange}
                    className="form-category w260"
                    ref={(ref) => (inputRef.current[6] = ref)}
                  >
                    <option value="">카테고리 선택</option>
                    {cteCode?.map((item) => {
                      return (
                        <option key={item.cd} value={item.cd}>
                          {item.cdName}
                        </option>
                      )
                    })}
                  </select>
                </td>
              </tr>
              {/* <input type="text"
                            title="이름"
                            className="form-control input-text"
                            placeholder="이름"
                            id="regName" name ="regName"
                            value = {state.regName}
                            onChange={handleChange}
                            ref={ref =>inputRef.current[0] = ref}                           
                            autoComplete = 'off'  //로그인 패스워드가 자꾸 자동완성되어서 막음.
                            /> */}
              {/* <input type="text"
                            title="이메일"
                            className="form-control input-text"
                            placeholder="이메일(이메일로 답변을 받기를 원하시는 경우 입력해 주십시오.)"
                            id="idEmail" name="idEmail"
                            value = {state.idEmail}
                            onChange={handleChange}
                            ref={ref =>inputRef.current[1] = ref}
                            autoComplete = 'off'  //로그인 정보가 자꾸 자동완성되어서 막음.
                            /> */}

              {/* 모바일 번호 제거 */}
              {/* <input type="text"
                            title="연락처"
                            className="form-control input-text"
                            placeholder="연락처( -(하이픈) 제외하고 숫자만 입력해주세요.)"
                            id="mobileNo" name="mobileNo"
                            value = {state.mobileNo}
                            onChange={handleChange}
                            ref={ref =>inputRef.current[2] = ref}
                            autoComplete = 'off'  //자꾸 자동완성되어서 막음.
                      /> */}

              <tr>
                  <th scope="row"> 비밀글 </th>
                  <td>
                  <input title="비밀글" type="checkbox" id="openYn" checked={state.openYn === 'N'} disabled />
{/* //                     <input title="비밀글" type="checkbox" id="openYn" checked={state.openYn === 'Y'} onChange={checkHandler} /> */}
                  </td>
              </tr>
              <tr>

                <th scope="row">비밀번호</th>
                <td>
                  {
                    // 수정화면에서는 패스워드 창 보이지 않도록 처리
                    mode === MODE_REGIS ? (
                      <input
                        type="password"
                        title="비밀번호"
                        className="form-keyword full"
                        placeholder="비밀번호(문의 내용을 공개하지 않으시려면 비밀번호를 입력해 주십시오.)"
                        id="encPasswd"
                        name="encPasswd"
                        value={state.encPasswd}
                        onChange={handleChange}
                        ref={(ref) => (inputRef.current[3] = ref)}
                        autoComplete="off" //자꾸 자동완성되어서 막음.
                      />
                    ) : (
                      <input
                        type="password"
                        title="비밀번호"
                        className="form-keyword full"
                        placeholder="비밀번호(비밀번호를 변경하시려면 비밀번호를 입력해 주십시오.)"
                        id="encPasswd"
                        name="encPasswd"
                        value={state.encPasswd}
                        onChange={handleChange}
                        ref={(ref) => (inputRef.current[3] = ref)}
                        autoComplete="off"
                      />
                    )
                  }
                </td>
              </tr>
              <tr>
                <th scope="row">
                  <em className="required"></em> 제목
                </th>
                <td>
                  <input
                    type="text"
                    title="제목"
                    className="form-keyword full"
                    placeholder="제목을 입력해주세요(제목은 50자 이내로 입력이 가능합니다.)"
                    id="questTitle"
                    name="questTitle"
                    value={state.questTitle}
                    onChange={handleChange}
                    maxLength="50"
                    ref={(ref) => (inputRef.current[4] = ref)}
                  />
                </td>
              </tr>
              <tr>
                <th scope="row">
                  <em className="required"></em> 내용
                </th>
                <td>
                  <textarea
                    className="textarea2"
                    title="내용"
                    placeholder="내용을 입력해주세요(최대 2000글자)"
                    id="question"
                    name="question"
                    value={state.question}
                    onChange={handleChange}
                    ref={(ref) => (inputRef.current[5] = ref)}
                  ></textarea>
                </td>
              </tr>
              {Common.getDeviceType() === 'MobileApp' || Common.getDeviceType() === 'MobileWeb' ? null : (
                <React.Fragment>
                  <tr>
                    <th scope="row">
                      <em></em> 첨부파일
                    </th>
                    <td>
                      <ul className="attach-list">
                        {generateFileInput(0)}
                        {generateFileInput(1)}
                        {generateFileInput(2)}
                      </ul>
                    </td>
                  </tr>
                </React.Fragment>
              )}
            </tbody>
          </table>
          <div className="btn-block">
            <span className="right">
              {mode === MODE_EDIT ? (
                <React.Fragment>
                  <Link to="/question" className="btn-primary md" style={{ marginRight: '10px' }}>
                    목록
                  </Link>
                  <button className="btn-primary md" onClick={edit} style={{ backgroundColor: '#419641' }}>
                    수정하기
                  </button>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <Link to="/question" className="btn-primary md" style={{ marginRight: '10px' }}>
                    목록
                  </Link>
                  <button className="btn-secondary md" onClick={() => reset('')} style={{ marginRight: '10px' }}>
                    초기화
                  </button>
                  <button className="btn-primary md" onClick={regist}>
                    문의하기
                  </button>
                </React.Fragment>
              )}
            </span>
          </div>
        </div>
      </main>
    </React.Fragment>
  )
}

const mapStateToProps = (state) => {
  return {
    cteCode: state.commoncode?.co?.QNA_CATEGORY_CD,
    registResult: state.quest?.registResult,
    select: state.quest.select,
    codeFail: state.commoncode?.isFailure,
    //    pwdConfirm : state.quest.pwdConfirm,
    token: state.quest.token,
  }
}

const actionCreator = {
  regis: questionActions.regis,
  edit: questionActions.edit,
  error: alertActions.error,
  checkFindInput: valid.checkFindInput,
  getCommonCode: commonActions.getCommonCode,
  success: alertActions.success,
  registReset: questionActions.registReset,
  detail: questionActions.detail,
}

export default connect(mapStateToProps, actionCreator)(QuestionWrite)
